import { MakeCall } from 'ha/services/apiV2/createMakeCall';

import { APIV2_URL } from './constants';
import { KYCEntity } from './types/Kyc';

export type GetUserKycByUuid = (
  userId: 'me' | number,
  kycUuid: string,
) => Promise<{ data: KYCEntity }>;

export default (makeCall: MakeCall): GetUserKycByUuid =>
  (userId = 'me', kycUuid) =>
    makeCall<KYCEntity>('GET', `${APIV2_URL}/user/${userId}/kyc/${kycUuid}`);
